import { combineReducers } from 'redux';

import autoSignin from './autoSignin';

const reducer = combineReducers({
  autoSignin,
});

export default reducer;
